import getCdnUrl from '../../../helpers/get-cdn-url';

const ChileFlagIcon = getCdnUrl('/flags/chile_flag_icon.svg');

export default ChileFlagIcon;
